import { isNotEmpty } from "utils/validate";
import { ResultElementSourceType, TableElementSourceType, } from "store/rs-workspace/rs-workspace.types";
import { SourceFields, SourceSourceFields, } from "../ProcessDataViewerElement/types";
import { OUTPUT_FINAL_ID } from "store/rs-workspace/selectors/rs-workspace.selectors";
export const prepareProcessDataViewerSourceDataForSelect = (sourceTemplate) => {
    const source = sourceTemplate[SourceFields.source];
    if (!source || source.type === undefined) {
        return;
    }
    switch (source.type) {
        case ResultElementSourceType.Simulation: {
            const preparedSimulationSource = {
                ...source,
                type: ResultElementSourceType.Simulation,
                simulationId: source[SourceSourceFields.simulationId] ?? undefined,
                optimizationId: source[SourceSourceFields.optimizationId] ?? undefined,
                adjustmentId: source[SourceSourceFields.adjustmentId] ?? undefined,
            };
            return preparedSimulationSource;
        }
        case ResultElementSourceType.ProcessData: {
            const preparedProcessDataSource = {
                ...source,
                type: ResultElementSourceType.ProcessData,
                processDataId: source?.processDataId ?? undefined,
            };
            return preparedProcessDataSource;
        }
        case ResultElementSourceType.Insight: {
            const preparedInsightSource = {
                ...source,
                type: ResultElementSourceType.Insight,
                insightId: source[SourceSourceFields.insightId] ?? undefined,
                inputSetId: source[SourceSourceFields.inputSetId] ?? undefined,
                ...(isNotEmpty(source[SourceSourceFields.outputId])
                    ? {
                        output: {
                            id: source[SourceSourceFields.outputId] ?? undefined,
                            isFinal: source[SourceSourceFields.outputId] === OUTPUT_FINAL_ID,
                        },
                    }
                    : { output: undefined }),
            };
            return preparedInsightSource;
        }
    }
};
export const prepareSpaceViewerSourceDataForSelect = (sourceTemplate) => {
    if (!sourceTemplate || sourceTemplate.type === undefined) {
        return;
    }
    switch (sourceTemplate.type) {
        case ResultElementSourceType.Simulation: {
            const preparedSimulationSource = {
                ...sourceTemplate,
                type: ResultElementSourceType.Simulation,
                simulationId: sourceTemplate[SourceSourceFields.simulationId] ?? undefined,
                adjustmentId: sourceTemplate[SourceSourceFields.adjustmentId] ?? undefined,
            };
            return preparedSimulationSource;
        }
        case ResultElementSourceType.Insight: {
            const preparedInsightSource = {
                ...sourceTemplate,
                type: ResultElementSourceType.Insight,
                insightId: sourceTemplate[SourceSourceFields.insightId] ?? undefined,
                inputSetId: sourceTemplate[SourceSourceFields.inputSetId] ?? undefined,
                ...(isNotEmpty(sourceTemplate[SourceSourceFields.outputId] || !!sourceTemplate[SourceSourceFields.isFinal])
                    ? {
                        output: {
                            id: sourceTemplate[SourceSourceFields.isFinal]
                                ? OUTPUT_FINAL_ID
                                : (sourceTemplate[SourceSourceFields.outputId] ?? undefined),
                            isFinal: sourceTemplate[SourceSourceFields.isFinal] ||
                                sourceTemplate[SourceSourceFields.outputId] === OUTPUT_FINAL_ID,
                        },
                    }
                    : { output: undefined }),
            };
            return preparedInsightSource;
        }
    }
};
export const prepareTableSourceDataForSelect = (row) => {
    if (!row || !isNotEmpty(row.sourceId)) {
        return undefined;
    }
    let payload;
    switch (row.sourceType) {
        case TableElementSourceType.PROCESS_DATA:
            payload = {
                ...row,
                type: ResultElementSourceType.ProcessData,
                processDataId: row.sourceId,
            };
            break;
        case TableElementSourceType.SIMULATION:
            payload = {
                ...row,
                type: ResultElementSourceType.Simulation,
                simulationId: row.sourceId,
                adjustmentId: row.adjustmentId ?? undefined,
            };
            break;
    }
    return payload;
};
